<template>
  <NxInput
    name="naturalizade"
    type="text"
    label="Naturalidade:"
    placeholder="Digite sua naturalizade"
    :value="localValue"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputNaturalidade',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputNaturalidade.vue